import type { AutoEventConfig } from '@models/AutoEventConfig'
import { formatDate } from '@util/date-util'

export { formatAutoEventConfig }

const formatAutoEventConfig = (config: AutoEventConfig): string => {
  const {
    netbeheerder,
    ingangsDatum,
    eindDatum,
    doorlooptijdWerkdagen,
    discipline,
  } = config
  const parts: string[] = [netbeheerder]

  if (discipline) {
    parts.push(` (${discipline})`)
  }

  parts.push(` vanaf ${formatDate(ingangsDatum)}`)

  if (eindDatum) {
    parts.push(` tot ${formatDate(eindDatum)}`)
  }

  const multiple = doorlooptijdWerkdagen !== 1

  parts.push(
    ` (doorlooptijd ${doorlooptijdWerkdagen} werkdag${multiple ? 'en' : ''})`,
  )

  return parts.join('')
}
